import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Breadcrumb.css';

const Breadcrumb = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    return (
        <nav aria-label="breadcrumb" className="breadcrumb-wrapper container mt-4">
            <ol className="breadcrumb">
                <li className="breadcrumb-item">
                    <Link to="/">HOME</Link>
                </li>
                {pathnames.map((name, index) => {
                    const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
                    const isLast = index === pathnames.length - 1;
                    const formatName = name.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

                    return isLast ? (
                        <li key={name} className="breadcrumb-item active" aria-current="page">
                            {formatName}
                        </li>
                    ) : (
                        <li key={name} className="breadcrumb-item ">
                            <Link to={routeTo}>{formatName}</Link>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
